// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_p7-0";
export var animationContainer = "_p7-1";
export var itemPrice = "_p7-a";
export var itemizedContent = "_p7-9";
export var itemizedHeader = "_p7-7";
export var itemizedRow = "_p7-8";
export var itemizedSection = "_p7-6";
export var modalContent = "_p7-2";
export var orderName = "_p7-3";
export var refundOption = "_p7-4";
export var refundOptionsContainer = "_p7-5";
export var shippingLabel = "_p7-b";
export var totalRow = "_p7-c";